/* Optional event adapters. Shopify channel integrations own pixel loading and checkout events. */
(() => {
  const node=document.getElementById('kobre-tracking');
  if(!node||window.Shopify?.designMode)return;
  const ids=JSON.parse(node.textContent);
  const privacy=()=>window.Shopify?.customerPrivacy;
  window.addEventListener('kobre:add_to_cart',event=>{
    const api=privacy();if(!api)return;
    const {value,currency}=event.detail||{};
    if(api.analyticsProcessingAllowed?.()&&/^G-[A-Z0-9]+$/.test(ids.GOOGLE_ANALYTICS_ID||'')&&typeof window.gtag==='function')
      window.gtag('event','add_to_cart',{send_to:ids.GOOGLE_ANALYTICS_ID,value,currency});
    if(api.marketingAllowed?.()){
      if(/^\d+$/.test(ids.META_PIXEL_ID||'')&&typeof window.fbq==='function')window.fbq('trackSingle',ids.META_PIXEL_ID,'AddToCart',{value,currency});
      if(/^[A-Z0-9]+$/i.test(ids.TIKTOK_PIXEL_ID||'')&&typeof window.ttq?.instance==='function')window.ttq.instance(ids.TIKTOK_PIXEL_ID).track('AddToCart',{value,currency});
    }
  });
})();
